module.exports = __webpack_public_path__ + "static/video-4-52f1a7881f4e894063901a0d1f07ea41.mp4";